

























import Vue from 'vue';
import CardLayout from '@/components/card-layout/CardLayout.vue';
import { Url, EventType } from '@/constants';

export default Vue.extend({
  name: 'FinancingAndPayments',
  components: {
    CardLayout
  },
  data () {
    return {
      paymentURL: Url.paymentPortal,
      femURL: Url.femPortal,
      EventType
    }
  },
  props: {
    preClose: {
      type: Boolean,
      required: true
    }
  }
})
